import React from 'react';

export default function EditButton(props) {
  const { onChange, children, isDisabled, primaryColor } = props;
  return (
    <button
      className="link-button edit"
      type="button"
      onClick={onChange}
      onKeyPress={onChange}
      alt="edit"
      style={{ color: primaryColor }}
      disabled={isDisabled}
    >
      {children}
    </button>
  );
}
